import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CustomerForPrintViewQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type CustomerForPrintViewQuery = {
  __typename?: 'Query'
  customer: {
    __typename?: 'Customer'
    id: number
    dateOfBirth?: any | null
    email: string
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    address?: {
      __typename?: 'OptionalAddress'
      street?: string | null
      city?: string | null
      zip?: string | null
      country?: string | null
    } | null
    membership?: {
      __typename?: 'Membership'
      uuid: string
      membershipNumber: string
      activatedAt: any
      product: { __typename?: 'Product'; id: number; name: string }
    } | null
    chat: {
      __typename?: 'MessagesCollection'
      items: Array<{
        __typename?: 'Message'
        appointmentAt?: any | null
        approvedAt?: any | null
        content?: string | null
        createdAt: any
        id: number
        sentAt?: any | null
        type: Types.MessageType
        updatedAt: any
        topicQuestionnaireAnswers?: any | null
        documents?: Array<
          | {
              __typename?: 'CustomerDocument'
              id: number
              name: string
              category?: {
                __typename?: 'CustomerDocumentCategory'
                id: number
                name: string
              } | null
              metadata: {
                __typename?: 'MetaData'
                utilityBillCheck?: {
                  __typename?: 'UtilityBillCheck'
                  moveInDate?: string | null
                  moveOutDate?: string | null
                  sizeOfFlat?: number | null
                  isCurrentAddress?: boolean | null
                } | null
              }
            }
          | { __typename?: 'LawyerDocument'; id: number; name: string }
        > | null
        topic: { __typename?: 'Topic'; id: number; name: string }
        lawyer?: { __typename?: 'Lawyer'; id: number; firstName: string; lastName: string } | null
      }>
    }
  }
}

export const CustomerForPrintViewDocument = gql`
  query CustomerForPrintView($id: Int!) {
    customer(id: $id) {
      id
      dateOfBirth
      email
      firstName
      lastName
      phone
      address {
        street
        city
        zip
        country
      }
      membership {
        uuid
        membershipNumber
        product {
          id
          name
        }
        activatedAt
      }
      chat(
        filters: { messageType: { in: [Question, Answer, Information] } }
        sorts: { createdAt: ASC }
      ) {
        items {
          appointmentAt
          approvedAt
          content
          createdAt
          documents {
            id
            name
            ... on CustomerDocument {
              category {
                id
                name
              }
              metadata {
                utilityBillCheck {
                  moveInDate
                  moveOutDate
                  sizeOfFlat
                  isCurrentAddress
                }
              }
            }
          }
          id
          sentAt
          topic {
            id
            name
          }
          type
          updatedAt
          topicQuestionnaireAnswers
          lawyer {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`
export function useCustomerForPrintViewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CustomerForPrintViewQuery,
    CustomerForPrintViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CustomerForPrintViewQuery, CustomerForPrintViewQueryVariables>(
    CustomerForPrintViewDocument,
    options
  )
}
export function useCustomerForPrintViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomerForPrintViewQuery,
    CustomerForPrintViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CustomerForPrintViewQuery,
    CustomerForPrintViewQueryVariables
  >(CustomerForPrintViewDocument, options)
}
export type CustomerForPrintViewQueryHookResult = ReturnType<typeof useCustomerForPrintViewQuery>
export type CustomerForPrintViewLazyQueryHookResult = ReturnType<
  typeof useCustomerForPrintViewLazyQuery
>
export type CustomerForPrintViewQueryResult = ApolloReactCommon.QueryResult<
  CustomerForPrintViewQuery,
  CustomerForPrintViewQueryVariables
>
export function refetchCustomerForPrintViewQuery(variables?: CustomerForPrintViewQueryVariables) {
  return { query: CustomerForPrintViewDocument, variables: variables }
}
